var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 136,
    viewBox: "0 0 136 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.2 135.1V88H93.9L96.9 68.4H78.2V55.8C78.2 50.4 80.8 45.2 89.2 45.2H97.7V28.6C92.5667 27.7333 87.5334 27.3 82.6 27.3C67.2 27.3 57.1 36.7 57.1 53.6V68.4H40V88H57.1V135.1C24.9 130.1 0.200012 102.1 0.200012 68.4C0.200012 31.2 30.4 0.899963 67.7 0.899963C104.9 0.899963 135.2 31.2 135.2 68.4C135.2 102.1 110.5 130.1 78.2 135.1Z",
    fill: "#4676ED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M78.2 88V135.1C74.8 135.633 71.3 135.9 67.7 135.9C64.1 135.9 60.5667 135.633 57.1 135.1V88H40V68.4H57.1V53.6C57.1 36.7 67.2 27.3 82.6 27.3C87.5333 27.3 92.5667 27.7333 97.7 28.6V45.2H89.2C80.8 45.2 78.2 50.4 78.2 55.8V68.4H96.9L93.9 88H78.2Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.6396ea13f7bdf8bfb51af5c3376cd2f3.svg";
export { ForwardRef as ReactComponent };